export const trips = {
  appBarTitle: "الرحلات",
  totalTrips: "إجمالى الرحلات",
  totalOngoingTrips: "إجمالى الرحلات الجارية",
  totalEndedTrips: "إجمالى الرحلات المنتهية",
  totalCoveredKms: "إجمالي الكيلومترات المغطاة",
  table: {
    tripId: "رقم الرحلة",
    driverName: "اسم السائق",
    ownerName: "اسم المالك",
    teamName: "اسم الفريق",
    startLocation: "موقع البداية",
    endLocation: "موقع النهاية",
    status: "الحالة",
    totalKms: "إجمالي الكيلومترات المغطاة",
    dateStart: "تاريخ البداية",
    level: "المستوى",
    role: "الدور",
    rolesOptions: {
      fleetOwner: "صاحب أسطول",
      singleOwner: "سائق حر",
      driver: "سائق في أسطول",
    },
    roleStatus: "حالة الدور",
    switchedFrom: "متغير من",
    roleStatusOptions: {
      primary: "اساسي",
      switched: "متغير",
    },
  },
  filters: {
    status: "الحالة",
    totalKmsCovered: "إجمالي الكيلومترات المغطاة",
    date: "التاريخ",
    teamName: "اسم الفريق",
    ownerName: "اسم المالك",
    driverName: "اسم السائق",
    level: "المستوى",
    role: "الدور",
    roleStatus: "حالة الدور",
    options: {
      coveredKms: {
        lessThan1: "أقل من 1 كم",
        moreThanOrEqual1: "أكبر من أو يساوى 1 كم",
        moreThanOrEqual5: "أكبر من أو يساوى 5 كم",
        moreThanOrEqual50: "أكبر من أو يساوى 50 كم",
        moreThanOrEqual100: "أكبر من أو يساوى 100 كم",
      },
      role: {
        fleetOwner: "صاحب أسطول",
        singleOwner: "سائق حر",
      },
      roleStatus: {
        primary: "اساسي",
        switchedFromSingleOwner: "متغير من سائق حر",
        switchedFromFleetOwner: "متغير من صاحب أسطول",
        switchedFromDriver: "متغير من سائق",
      },
    },
  },
  ongoing: "جارية",
  ended: "منتهية",
  tripDetails: {
    title: "تفاصيل الرحلة",
    forceEndTrip: "إنهاء الرحلة بالقوة",
    forceEndTripConfirm:
      "هل أنت متاكد من إنهاء هذه الرحلة بالقوة؟ هذه العملية غير قابلة للتراجع.",
    plateNumber: "رقم اللوحة",
    tripId: "رقم الرحلة",
    teamName: "اسم الفريق",
    driverName: "اسم السائق",
    ownerName: "اسم المالك",
    tripStartTime: "وقت بدء الرحلة",
    tripStartDate: "تاريخ بدء الرحلة",
    duration: "مدة الرحلة",
    totalKmsCovered: "إجمالي الكيلومترات المغطاة",
    startLocation: "موقع البداية",
    endLocation: "موقع النهاية",
    liveTrip: "رحلة جارية",
    tripEnded: "رحلة منتهية",
    noMapTitle: "الخريطة ليست جاهزة بعد",
    noMapNote: "بمجرد انتهاء الرحلة، ستكون الخريطة متاحة",
    km: "كم",
    min: "دقيقة",
    level: "المستوى",
    role: "الدور",
    rolesOptions: {
      fleetOwner: "صاحب أسطول",
      singleOwner: "سائق حر",
      driver: "سائق في أسطول",
    },
    roleStatus: "حالة الدور",
    switchedFrom: "متغير من",
    roleStatusOptions: {
      primary: "اساسي",
      switched: "متغير",
    },
  },
};
